<!--样式引入-->
<style scoped lang="scss" src="./index.scss"></style>

<!--模版引入-->
<template lang="pug" src="./index.pug">
</template>

<script>
export default {
  components: {},
  data() {
    return {
      userPhone: "", //手机号
      capCode: "", //验证码
      agree: false,
      sec: 0, //倒计时
    };
  },
  computed: {
    okSub() {
      if (
        !this.$glf.isEmpty(this.userPhone) &&
        !this.$glf.isEmpty(this.capCode) &&
        !this.$glf.isEmpty(this.agree)
      ) {
        return "okSub";
      } else {
        return "";
      }
    },
  },
  watch: {},
  created: function () {},
  mounted: function () {
    if (this.$store.state.authToken) {
      this.$toast('您当前已登陆');
      this.$router.back();
    }
  },
  methods: {
    //发送验证码
    sendMsgCode() {
      this.$toast.clear();
      if (this.$glf.isEmpty(this.userPhone)) {
        this.$toast("请输入手机号");
        return false;
      }
      if(!/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(this.userPhone)){
        this.$toast('手机号码格式不正确');
        return false;
      }
      this.$toast.loading({
        message: "发送中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });

      this.$api.sms({ mobile: this.userPhone.trim() }).then((res) => {
        this.$toast("手机号验证码发送成功");
        //开始倒计时
        this.sec = 59;
        let t = setInterval(() => {
          this.sec -= 1;
          if (this.sec <= 0) {
            clearInterval(t);
          }
        }, 1000);
      });
    },

    //监听提交
    onSubmit() {
      if (this.$glf.isEmpty(this.userPhone)) {
        this.$toast("请输入手机号");
        return false;
      }
      if(!/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(this.userPhone)){
        this.$toast('手机号码格式不正确');
        return false;
      }
      if (this.$glf.isEmpty(this.capCode)) {
        this.$toast("请输入验证码");
        return false;
      }
      if (!this.agree) {
        this.$toast("请勾用户协议和隐私政策");
        return false;
      }
      this.$toast.loading({
        message: "登陆中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });
      var params = {
        mobile: this.userPhone.trim(),
        smsCode: this.capCode.trim(),
      };
      //登录
      this.$api.login(params).then((token) => {
        this.$store.commit("setAuthToken", token.data);
        //获取登录用户详情
        this.$api.loginUserDetail().then((res) => {
          var uf = res.data;
          if(uf.competent){
            uf.competent = JSON.parse(uf.competent)
          }else{
            uf.competent = [];
          }
          this.$store.commit("setUserInfo", uf);
          setTimeout(() => {
            // this.$glf.goUrl('replace','/master',);
            this.$router.replace({name:'master',params:{nav:-1}})
            this.$toast.clear();
          }, 500);
        });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/login/index.vue